export const handleError = (response: any) => {
  if (response?.data?.error) {
    throw new Error(response.data.error.message);
  }
  if (response?.data?.data?.isFailure) {
    throw new Error(response.data.data.error.message);
  }
  return response;
};
